import { MaskReveal } from "./Reveal";
import { motion } from "framer-motion";

// Inner-page hero banner
export function PageHero({ index, kicker, titleLines, subtitle }) {
  return (
    <section
      data-testid="page-hero"
      className="relative overflow-hidden border-b border-white/10 bg-ink px-6 pb-20 pt-44 md:px-12 md:pt-52"
    >
      <div className="pointer-events-none absolute -right-40 top-0 h-[500px] w-[500px] rounded-full bg-bluecore/20 blur-[130px]" />
      <div className="pointer-events-none absolute left-1/4 top-1/2 h-[300px] w-[300px] rounded-full bg-crimson/10 blur-[120px]" />

      <div className="relative mx-auto max-w-[1500px]">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="mb-8 flex items-center gap-4"
        >
          <span className="font-mono text-xs text-crimson">{index}</span>
          <span className="h-px w-16 bg-white/20" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">
            {kicker}
          </span>
        </motion.div>

        <h1 className="font-serif text-5xl font-light leading-[0.95] tracking-tight text-white sm:text-6xl md:text-8xl">
          <MaskReveal lines={titleLines} delay={0.15} />
        </h1>

        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            className="mt-8 max-w-2xl text-lg leading-relaxed text-white/55"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
